export default __webpack_public_path__ + "static/Group 1728-146f602494f9dde5d0ce3e2b280eb861.png";